import React from 'react';
import {Col, Container, Row} from 'react-bootstrap';
import {StyleSheet} from 'react-native';
import {Text, View, Dimensions} from 'react-native';
import {TouchableOpacity} from 'react-native-gesture-handler';
import HomeHeader from '../../components/HomeHeader';
import {BsChevronRight} from 'react-icons/bs';
import {useLinkTo} from '@react-navigation/native';

const HEIGHT = Dimensions.get('window').height;

export default function PaymentScreen(props) {

  return (
    <View
      style={{
        height: HEIGHT,
      }}>
      <HomeHeader navigation={props.navigation} />
      <Text style={styles.header}>Select an online payment option</Text>
      <Text style={styles.subHeader}>
        Choose to pay via Card, Net Banking, Wallets and more
      </Text>
      <Container>
        <Row>
          <Col md={3}></Col>
          <Col md={6}>
            <View style={styles.totalPayment}>
              <View>
                <Text style={styles.amount}>Total Amount</Text>
                <Text style={styles.pack}>(Set Top Box + pack)</Text>
              </View>
              <View>
                <Text style={styles.price}>2917.00</Text>
              </View>
            </View>
          </Col>
          <Col md={3}></Col>
        </Row>
      </Container>
      <Container>
        <Row>
          <Col md={2}></Col>
          <Col md={8}>
            <View>
              <Text style={styles.paymentHeader}>Payment Options</Text>
              <TouchableOpacity style={styles.termsAndConditions}>
                <Text style={styles.question}>Credit Card</Text>
                <BsChevronRight color={'lightgray'} size={20} />
              </TouchableOpacity>
              <TouchableOpacity style={styles.termsAndConditions}>
                <Text style={styles.question}>Debit Card</Text>
                <BsChevronRight color={'lightgray'} size={20} />
              </TouchableOpacity>
              <TouchableOpacity style={styles.termsAndConditions}>
                <Text style={styles.question}>Net Banking</Text>
                <BsChevronRight color={'lightgray'} size={20} />
              </TouchableOpacity>
            </View>
          </Col>
          <Col md={2}></Col>
        </Row>
      </Container>
    </View>
  );
}

const styles = StyleSheet.create({
  header: {
    color: 'lightgray',
    alignSelf: 'center',
    marginTop: 30,
    fontWeight: 'bold',
    fontSize: 25,
  },
  question: {
    color: 'gray',
    fontSize: 17,
  },
  termsAndConditions: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    borderBottomWidth: 1,
    borderColor: 'gray',
    paddingVertical: 10,
    marginVertical: 10,
  },
  subHeader: {
    color: 'gray',
    alignSelf: 'center',
    marginTop: 10,
  },
  totalPayment: {
    alignSelf: 'center',
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginVertical: 30,
    boxShadow: `${0}px ${0}px ${5}px #00000094`,
    padding: 20,
    borderRadius: 6,
  },
  amount: {
    color: 'gray',
    fontSize: 20,
  },
  pack: {
    color: 'gray',
    fontSize: 12,
  },
  price: {
    color: 'gray',
    fontSize: 20,
  },
  paymentHeader: {
    color: 'lightgray',
    fontSize: 18,
    // fontWeight: 'bold',
    marginBottom: 10,
    borderBottomWidth: 1,
    borderColor: 'gray',
    paddingVertical: 10,
  },
});
